
import Vue from 'vue';
import { minLength, required } from 'vuelidate/lib/validators';
import { Validation } from 'vuelidate/vuelidate';

import Modal from '@/components/modal/Modal.vue';
import { Subscriber } from '@/interfaces/notifications';

interface SubscriberForm {
	name: string;
	type: 'email' | 'sms';
	address: string;
}

interface ComponentData {
	form: SubscriberForm;
	types: { value: 'email' | 'sms'; text: string }[];
	subscriber: Subscriber | null;
}

export default Vue.extend({
	components: {
		Modal,
	},
	data(): ComponentData {
		return {
			form: {
				name: '',
				type: 'email',
				address: '',
			},
			types: [
				{ value: 'email', text: this.$t('E-mail').toString() },
				{ value: 'sms', text: this.$t('SMS').toString() },
			],
			subscriber: null,
		};
	},

	validations: {
		form: {
			name: {
				required,
				minLength: minLength(3),
			},
			type: {
				required,
			},
			address: {
				required,
			},
		},
	},

	computed: {
		addressLabel(): string {
			switch (this.form.type) {
				case 'email':
					return this.$t('Address').toString();
				case 'sms':
					return this.$t('Phone number').toString();
				default:
					return this.$t('Address').toString();
			}
		},
	},

	methods: {
		show(subscriber?: Subscriber) {
			this.reset();
			if (subscriber) {
				this.subscriber = subscriber;
				this.form = this.makeForm(subscriber);
			}
			this.$bvModal.show('modal-notification-subscriber');
		},
		hide() {
			this.$bvModal.hide('modal-notification-subscriber');
		},
		reset() {
			this.form = {
				name: '',
				type: 'email',
				address: '',
			};
			this.subscriber = null;
			this.$v.form.$reset();
		},

		confirm() {
			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				return;
			}
			if (this.subscriber === null) {
				const subscriber: Partial<Subscriber> = {
					name: this.form.name,
					type: this.form.type,
					address: this.form.address,
				};
				this.$emit('create', subscriber);
			} else {
				const subscriber: Partial<Subscriber> = {
					...this.subscriber,
					name: this.form.name,
					type: this.form.type,
					address: this.form.address,
				};
				this.$emit('modify', subscriber);
			}
		},

		validateState(validation: Validation): boolean | null {
			const { $dirty, $error } = validation;
			return $dirty ? !$error : null;
		},

		makeForm(subscriber: Subscriber): SubscriberForm {
			return {
				name: subscriber.name,
				type: subscriber.type,
				address: subscriber.address,
			};
		},
	},
});
